export default __webpack_public_path__ + "static/media/1.f07b4783.png";